import React, { useState, useEffect } from 'react';
import { authFetch } from "../../utils/api";
import "../../styles/admin/Solicitudes.css"; 

const CheckIcon = () => <span className="icon-approve">&#10003;</span>;
const CloseIcon = () => <span className="icon-reject">&#10005;</span>;


function Solicitudes() {
  const [allSolicitudes, setAllSolicitudes] = useState([]); 
  const [solicitudes, setSolicitudes] = useState([]); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
 
  const [filtroEstado, setFiltroEstado] = useState('Pendiente'); 
  const [searchTerm, setSearchTerm] = useState(''); 

  useEffect(() => {
    const fetchSolicitudes = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await authFetch('/api/Solicitudes'); 
        if (!response.ok) {
          throw new Error('Error al cargar los datos');
        }
        const data = await response.json();
        
        setAllSolicitudes(data); 

      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSolicitudes();
  }, []); 

  
  
  useEffect(() => { 
    let dataFiltrada = [...allSolicitudes];

    if (filtroEstado) {
      dataFiltrada = dataFiltrada.filter(s => s.estadoDeAprobacion === filtroEstado);
    }

    if (searchTerm) {
      dataFiltrada = dataFiltrada.filter(s => 
        s.nombre.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setSolicitudes(dataFiltrada); 

  }, [allSolicitudes, filtroEstado, searchTerm]); 


  const handleApprove = async (id) => {
    try {
      const response = await authFetch(`/api/Solicitudes/${id}/aprobar`, {
        method: 'POST',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al aprobar la solicitud');
      }

      setAllSolicitudes(prev => 
        prev.map(s => 
          s.id === id ? { ...s, estadoDeAprobacion: 'Aprobada' } : s
        )
      );
      
      alert('Solicitud aprobada y lugar creado exitosamente.');

    } catch (err) {
      alert(err.message);
    }
  };

  const handleReject = async (id) => {
    if (!window.confirm('¿Seguro que quieres rechazar esta solicitud?')) {
      return;
    }

    try {
      const response = await authFetch(`/api/Solicitudes/${id}`, {
        method: 'DELETE'
      });

      if (!response.ok) {
        throw new Error('Error al rechazar la solicitud');
      }

      setAllSolicitudes(prev => prev.filter(s => s.id !== id));
      alert('Solicitud rechazada y eliminada');

    } catch (err) {
      alert(err.message);
    }
  };

  const formatFecha = (fechaISO) => {
    return new Date(fechaISO).toLocaleDateString('es-MX', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  return (
    <div className="solicitudes-container">
      <header className="solicitudes-header">
        <h1>Solicitudes Pendientes</h1>
        <p>Revisa y gestiona las solicitudes de registro para las nuevas entidades en el sistema.</p>
      </header>

      <div className="filtros-container">

        <input 
          type="search" 
          placeholder="&#x1F50D; Buscar por nombre de entidad..." 
          className="search-bar"
          value={searchTerm} 
          onChange={e => setSearchTerm(e.target.value)}
        />
        
        <select 
          className="filtro-select"
          value={filtroEstado}
          onChange={e => setFiltroEstado(e.target.value)}
        >
          <option value="Pendiente">Pendientes</option>
          <option value="Aprobada">Aprobadas</option>
          <option value="Rechazada">Rechazadas</option>
          <option value="">Todas</option>
        </select>
        
        <select className="filtro-select">
          <option value="">Fecha (No implementado)</option>
        </select>
      </div>

      <div className="tabla-solicitudes">
        <div className="tabla-header">
          <div className="cell checkbox-cell"><input type="checkbox" /></div>
          <div className="cell">NOMBRE ENTIDAD</div>
          <div className="cell">TIPO ENTIDAD</div>
          <div className="cell">FECHA SOLICTUD</div>
          {filtroEstado === 'Pendiente' && (
             <div className="cell actions-cell">ACCIONES</div>
          )}
        </div>

        {loading && <div className="tabla-row-centered">Cargando...</div>}
        {error && <div className="tabla-row-centered error">{error}</div>}
        
        {!loading && !error && solicitudes.length === 0 && (
          <div className="tabla-row-centered">
            {filtroEstado === 'Pendiente' ? 'No hay solicitudes pendientes.' : 'No se encontraron resultados para este filtro.'}
          </div>
        )}

        {!loading && !error && solicitudes.map(solicitud => (
          <div className="tabla-row" key={solicitud.id}>
            <div className="cell checkbox-cell"><input type="checkbox" /></div>
            <div className="cell" data-label="Nombre">{solicitud.nombre}</div>
            <div className="cell" data-label="Tipo">{solicitud.tipoIndustria}</div>
            <div className="cell" data-label="Fecha">{formatFecha(solicitud.fecha)}</div>
            
            {filtroEstado === 'Pendiente' && (
              <div className="cell actions-cell">
                <button 
                  className="action-button approve" 
                  onClick={() => handleApprove(solicitud.id)} 
                  aria-label="Aprobar"
                >
                  <CheckIcon />
                </button>
                <button 
                  className="action-button reject" 
                  onClick={() => handleReject(solicitud.id)}
                  aria-label="Rechazar"
                >
                  <CloseIcon />
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      <footer className="tabla-footer">
        <span className="footer-info">Mostrando {solicitudes.length} resultados</span>
      </footer>
    </div>
  );
}

export default Solicitudes;